"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";

/** Wraps next-themes so the root layout (a server component) can mount the
 *  client-side theme context. `attribute="class"` toggles the `.dark` class on
 *  <html>, which is exactly what globals.css keys off
 *  (`@custom-variant dark (&:is(.dark *))` + the `.dark { … }` token block). */
export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
